export default "__VITE_ASSET__DJVCTvz5__"